import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/global/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/global/bootstrap-tema.css'; // tokens del sistema aplicados a Bootstrap (debe ir después)
import './style/areas/index.css';           // contextos de área: .area-rti, .area-art, .area-recepcion, etc.
import './style/components/sistema-ui.css'; // KPIs, tarjetas de sección y formularios unificados
import './utils/graficos'; // paleta y defaults de Chart.js del sistema
import './style/components/recepcion-ui.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // 👈 importante también
import 'bootstrap-icons/font/bootstrap-icons.css';
import './style/global/mobile.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Tema MUI alineado con los tokens de style/global/index.css (sistema de diseño GestiónEJP).
// MUI necesita valores literales para calcular tonos: si cambia un token, cambiarlo también acá.
const theme = createTheme({
  palette: {
    primary: { main: '#2563eb', light: '#3b82f6', dark: '#1d4ed8', contrastText: '#ffffff' },
    secondary: { main: '#64748b', light: '#94a3b8', dark: '#475569', contrastText: '#ffffff' },
    success: { main: '#15803d', light: '#10b981', dark: '#166534', contrastText: '#ffffff' },
    error: { main: '#dc2626', light: '#ef4444', dark: '#991b1b', contrastText: '#ffffff' },
    warning: { main: '#f59e0b', light: '#fcd34d', dark: '#92400e', contrastText: '#1e293b' },
    info: { main: '#0369a1', light: '#0ea5e9', dark: '#075985', contrastText: '#ffffff' },
    background: { default: '#f8fafc', paper: '#ffffff' },
    text: { primary: '#1e293b', secondary: '#64748b', disabled: '#94a3b8' },
    divider: '#e2e8f0',
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    // MUI usa h4/h5/h6 como títulos de página/sección/tarjeta: se mapean a la escala del sistema.
    h1: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.1, letterSpacing: '-0.02em' },
    h2: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.02em' },
    h3: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3, letterSpacing: '-0.01em' },
    h4: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.02em' },
    h5: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3, letterSpacing: '-0.01em' },
    h6: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.35 },
    subtitle1: { fontSize: '1rem', fontWeight: 500 },
    subtitle2: { fontSize: '0.8125rem', fontWeight: 500 },
    body1: { fontSize: '1rem', lineHeight: 1.6 },
    body2: { fontSize: '0.875rem', lineHeight: 1.5 },
    caption: { fontSize: '0.75rem', lineHeight: 1.4 },
    overline: { fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.06em', lineHeight: 1.3 },
    button: { fontSize: '0.875rem', fontWeight: 500, textTransform: 'none' },
  },
  components: {
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 16 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <App />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        </ThemeProvider>
    </React.StrictMode>
);

reportWebVitals();
